import API from "../api";

export const getAdminPaymentMethods = () =>
  API.get("/admin/payment-methods").then((r) => r.data || []);

export const saveAdminPaymentMethods = (methods) =>
  API.post("/admin/payment-methods", methods).then((r) => r.data || []);

export const testGatewayConnection = (payload) =>
  API.post("/admin/payment-methods/test-connection", payload).then((r) => r.data);

export const getPaymentGatewayOverview = () =>
  API.get("/admin/payment-methods/overview").then((r) => r.data);

export const getStaffPaymentMethods = () =>
  API.get("/payment-methods/staff").then((r) => r.data || []);

export const getStudentPaymentMethods = () =>
  API.get("/public/payment-methods").then((r) => r.data || []);

export const chooseDefaultPaymentMethod = (methods, fallback = "CASH") => {
  const list = Array.isArray(methods) ? methods : [];
  if (!list.length) return fallback;
  const normalizedFallback = String(fallback || "").toUpperCase();
  const preferred = list.find(
    (m) => String(m.methodKey || "").toUpperCase() === normalizedFallback,
  );
  if (preferred) return preferred.methodKey;
  return list[0]?.methodKey || fallback;
};
